import { render, staticRenderFns } from "./Saldo.vue?vue&type=template&id=00f07764&"
import script from "./Saldo.vue?vue&type=script&lang=js&"
export * from "./Saldo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports